import React, { useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import { Link } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import { LoginAction } from "../../store/slices/authenticationSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import validation from "./validation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import ForgotPassword from "components/forgot-password/ForgotPassword";

import { LuMonitor } from "react-icons/lu";
import { TbSettingsAutomation } from "react-icons/tb";
import { BsGraphUp } from "react-icons/bs";
import { BiSupport } from "react-icons/bi";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { Logolandingpage, LogoSymbol } = Imagesdata || {};
  const [userInfo, setUserInfo] = useState({ email: "", password: "" });
  const {
    register,
    handleSubmit,
    setError,
    reset,
    setValue,
    control,
    formState: { errors, isValid, isSubmitted },
  } = useForm({ ...validation, mode: "onSubmit" });

  const [viewBtn, setViewBtn] = useState(false);

  const [forgotShow, setForgotShow] = useState(false)
  const handleClose = () => setForgotShow(false);

  const dispatch = useDispatch();
  const submitHandler = async (e) => {
    e.preventDefault();
    const statusMain = await dispatch(
      LoginAction({
        email: userInfo.email,
        password: userInfo.password,
      })
    );
    if (statusMain) {
      navigate("/dashboard");
      toast.success("Login Successfull*", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
    } else {
      toast.error("Username or Password is Incorrect*", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
    }
  };
  return (
    <section className="login-page">
      <div className="topbar">
        <div className="container-lg">
          <figure>
            <a href="/" className="logo">
              <img alt="" src={LogoSymbol} /> <p>360</p>
            </a>
          </figure>
          {/* <p>
            We make your stay just as enjoyable an experience as you can imagine
          </p> */}
        </div>
      </div>
      <div className="login-panel">
        <div className="container-lg">
          <div className="row">
            <div className="col-lg-6">
              <div className="col-left">
                <h1>Boost your property management with <span className="text-logo">RROOMS 360 PMS</span></h1>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="column">
                      <div className="flex align-items-center">
                        <span className="icon"><LuMonitor /></span>
                        <h6>Centralized <span>Platform</span></h6>
                      </div>
                      <p>Manage all operations from one unified interface</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="column">
                      <div className="flex align-items-center">
                        <span className="icon"><TbSettingsAutomation /></span>
                        <h6>Automated <span>Workflows</span></h6>
                      </div>
                      <p>Optimize tasks and improve operational efficiency</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="column">
                      <div className="flex align-items-center">
                        <span className="icon"><BsGraphUp /></span>
                        <h6>Revenue <span>Management</span></h6>
                      </div>
                      <p>Maximize profitability with dynamic pricing tools</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="column">
                      <div className="flex align-items-center">
                        <span className="icon"><BiSupport /></span>
                        <h6>24/7 <span>Support</span></h6>
                      </div>
                      <p>Access expert assistance anytime, day or night</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 last">
              <div className="col-right">
                <div className="form-wrap">
                  <div className="head">Admin Login</div>
                  <div className="admin-login-form form-inner">
                    <h2>Login</h2>
                    <form onSubmit={submitHandler}>
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="text"
                          placeholder="Email"
                          value={userInfo.email}
                          onChange={(e) =>
                            setUserInfo({ ...userInfo, email: e.target.value })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>Password</label>
                        <div className="icon_input">
                          <input
                            type={viewBtn ? "text" : "password"}
                            placeholder="**********"
                            value={userInfo.password}
                            onChange={(e) =>
                              setUserInfo({ ...userInfo, password: e.target.value })
                            }
                          />
                          <div onClick={() => setViewBtn(!viewBtn)}>
                            <FontAwesomeIcon
                              icon={`fa-solid  ${viewBtn ? "fa-eye-slash" : "fa-eye"
                                }`}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <button type="submit" className="btn btn-success" style={{ padding: "9px 40px" }}>Login</button>
                      </div>
                      <p className="mb-0">
                        <span className="text-danger cursor-pointer fs-8" onClick={() => setForgotShow(true)}>Forget Password</span>
                      </p>
                    </form>
                  </div>
                  <div className="tag"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ForgotPassword show={forgotShow} onHide={handleClose} userType="rroomUser" />
    </section>
  );
};

export default AdminLogin;
